import numberal from '@tiger/numeral';
import { Button } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import IconDeposit from './images/icon-deposit.png';

import './style.scss';

interface IRecordItemPorps {
    record: any;
    checkVoncherPicture(any): void;
}

const RecordItem: React.FC<IRecordItemPorps> = props => {
    const { created_at, currency, amount, bank_account, voucher_pictures } = props.record;

    return (
        <div className="deposit-record-item">
            <img src={IconDeposit} alt="" />
            <div className="item-content">
                <div className="content header">
                    <div className="amount">
                        <span>{numberal(amount).format('0,0.00')}</span> {currency}
                    </div>
                    <div className="account">{bank_account}</div>
                </div>
                <div className="content">
                    <span>{created_at ? dayjs(created_at).format('YYYY-MM-DD') : ''}</span>
                    <Button
                        type="link"
                        disabled={!voucher_pictures}
                        onClick={() => props.checkVoncherPicture(voucher_pictures)}>
                        {__('汇款凭证')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default RecordItem;
